import { useEffect, useState } from 'react';
import api from '../services/api';
import { horaTexto, RANGO_HORA } from './ordenes';
import { FRANJAS, pisaFranja } from './franjas';

// Días ocupados de los técnicos por trabajo propio (5-oct-2026).
// franja: una de las 4 franjas ("12:00-14:00", 20-oct-2026), 'DIA', un horario a mano
// ("09:00-13:00") o, en los viejos, 'MANANA' | 'TARDE'.
export const FRANJAS_BLOQUEO = [
    ...FRANJAS.map(f => ({ id: f.id, label: f.corto })),
    { id: 'DIA', label: 'Todo el día' },
];
export const DIAS_SEMANA = ['', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'];
const VIEJOS = { MANANA: 'mañana', TARDE: 'tarde', DIA: 'todo el día' };
export const labelFranja = (f) => {
    const fr = FRANJAS.find(x => x.id === f);
    if (fr) return `de ${fr.corto}`;
    if (RANGO_HORA.test(String(f || ''))) return `de ${horaTexto(f)}`;
    return VIEJOS[f] || String(f || '').toLowerCase();
};

// ¿Está ocupado ese técnico ese día en esa franja (id "08:00-10:00")? Se pisa con el horario marcado.
export const estaOcupado = (bloqueos, tecnicoId, iso, franjaId) => bloqueos.some(b => {
    if (b.tecnicoId !== tecnicoId || b.fecha !== iso) return false;
    if (b.franja === 'DIA') return true;
    return pisaFranja(b.franja === 'MANANA' ? 'Mañana' : b.franja === 'TARDE' ? 'Tarde' : b.franja, franjaId);
});

// Ocupaciones día por día entre dos fechas ISO (admin: de todos)
export function useBloqueos(desde, hasta, version = 0) {
    const [lista, setLista] = useState([]);
    useEffect(() => {
        if (!desde || !hasta) return;
        let vivo = true;
        api.get('/bloqueos/agenda', { params: { desde, hasta } })
            .then(r => { if (vivo) setLista(Array.isArray(r.data) ? r.data : []); })
            .catch(() => { if (vivo) setLista([]); });
        return () => { vivo = false; };
    }, [desde, hasta, version]);
    return lista;
}
